export const inputStyleClassName = "login-input-style"

export const inputErrorStyling = "login-input-error-styling"
export const buttonStyleClassName = "login-button-style"

export const errorBoxStyleClassName = "login-error-box-style"

export const titleStyleClassName = "login-title-style"
